// extracted by mini-css-extract-plugin
export default {"priceListPage":"PriceListPage_priceListPage__g99cr","tableRow":"PriceListPage_tableRow__Jjjru"};